// extracted by mini-css-extract-plugin
export var contact = "ContactSection-module--contact--IXjHP";
export var phoneNumber = "ContactSection-module--phone-number--2-Aeu";
export var email = "ContactSection-module--email--3Q6PP";